import { useStore } from '@/utils/vue-api';
import { computed } from 'vue';

export function useMenuTree() {
	const store = useStore();
	const commonData = computed(() => store.getters.getCommonData);
	const moduleIndexMap = computed(() => commonData.value?.__moduleIndexMap);
	const uuidIndexMap = computed(() => commonData.value?.__uuidMap);

	/* =========================
	 * 对外查询能力
	 * ========================= */

	function getMenuUuidsByModuleId(moduleId) {
		if (!moduleId) return [];
		if (!moduleIndexMap.value) return [];

		return Array.from(moduleIndexMap.value.get(moduleId) || []);
	}

	function getMenuByUuid(uuid) {
		if (!uuid) return null;
		if (!uuidIndexMap.value) return null;

		return uuidIndexMap.value.get(uuid) || null;
	}

	return {
		getMenuUuidsByModuleId,
		getMenuByUuid
	};
}
